// extracted by mini-css-extract-plugin
module.exports = {"fa-user-o":"Input_fa-user-o__1FTHA","fa-heart-o":"Input_fa-heart-o__1lfpp","fa-shopping-basket":"Input_fa-shopping-basket__2PYFG","fa":"Input_fa__1X9L5"};